import { useRef, useEffect } from 'react';

import MuxVideo, { Props as VideoProps } from '@mux/mux-video-react';
import dynamic from 'next/dynamic';

// DOCS: https://github.com/muxinc/elements/blob/main/packages/mux-video-react/README.md#primary-props
export const Video = ({ autoPlay, ...props }: Partial<VideoProps>) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  // workaround for autoplay, so it always work
  useEffect(() => {
    if (!autoPlay) {
      return; // do not trigger workaround if autoplay is disabled
    }
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error('Error attempting to play', error);
      });
    }
  }, [autoPlay]);

  // autoPlay -> check workaroud above
  return <MuxVideo placeholder={undefined} {...props} autoPlay={false} ref={videoRef} />;
};

const DynamicVideo = dynamic(
  () => import('@/common/components/Video/Video').then((module) => module.Video),
  { ssr: false },
);
const VideoElement = MuxVideo; // expose video element without additional magic

export { Video as default, DynamicVideo, VideoElement };
